// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__kwdxN","horizontal":"tabs_horizontal__BSu_C","vertical":"tabs_vertical__MZluq","panels-container":"tabs_panels-container__wz_pW"};